import localStore from '@/utils/localStore'
import i18n from '@/i18n'

export default {
  state: {
    pcTheme: '',
    mobileTheme: '',
    locale: '',
    printing: false
  },
  mutations: {
    SET_PC_THEME: (state, theme) => {
      state.pcTheme = theme
    },
    SET_MOBILE_THEME: (state, theme) => {
      state.mobileTheme = theme
    },
    SET_LOCALE: (state, locale) => {
      state.locale = locale
    },
    SET_PRINTING: (state, flag) => {
      state.printing = flag
    }
  },
  actions: {
    SetTheme({ commit }, { type, theme }) {
      if (type === 'pc') {
        commit('SET_PC_THEME', theme)
      } else if (type === 'mobile') {
        commit('SET_MOBILE_THEME', theme)
      }
    },
    SetLocale({ commit, state }, locale) {
      localStore.set('locale', locale)
      commit('SET_LOCALE', locale)
      i18n.locale = locale
    },
    SetPrinting({ commit }, flag) {
      commit('SET_PRINTING', flag)
    }
  }
}
